document.addEventListener('DOMContentLoaded', function () {
  var page = document.querySelector('[data-qb-page]');
  if (!page) return;

  var cards = Array.prototype.slice.call(page.querySelectorAll('[data-qb-card]'));
  var refresh = page.querySelector('[data-qb-refresh]');

  function shuffle(items) {
    var copy = items.slice();
    for (var i = copy.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = copy[i];
      copy[i] = copy[j];
      copy[j] = swap;
    }
    return copy;
  }

  function showBooks() {
    cards.forEach(function (card) { card.hidden = true; });
    shuffle(cards).slice(0, 4).forEach(function (card) { card.hidden = false; });
  }

  if (cards.length) showBooks();
  if (refresh) refresh.addEventListener('click', showBooks);

  page.querySelectorAll('a[href="#qb-products"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById('qb-products');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
